export default __webpack_public_path__ + "static/media/box_circle.583dc63c.svg";